export default __webpack_public_path__ + "UI/assets/media/starBlank-d93933ff.svg";